<div
  class="mx-auto flex max-w-7xl flex-col px-4 sm:px-6 lg:px-8"
  [style.height]="loading() || ticket() ? chatViewportHeight : null"
  [class.py-8]="!loading() && !ticket()"
  [class.py-4]="loading() || !!ticket()">
  @if (loading()) {
    <div class="flex min-h-0 flex-1 flex-col" aria-busy="true" aria-label="Loading ticket">
      <div class="flex shrink-0 flex-wrap items-start justify-between gap-4">
        <div class="min-w-0">
          <div class="flex items-center gap-2">
            <button
              type="button"
              (click)="goBack()"
              class="inline-flex shrink-0 items-center text-secondary hover:text-primary"
              aria-label="Back to queue">
              <svg class="size-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
              </svg>
            </button>
            <div class="h-7 w-64 max-w-full animate-pulse rounded bg-gray-200 dark:bg-zinc-700"></div>
          </div>
          <div class="mt-2 ml-7 h-4 w-40 animate-pulse rounded bg-gray-100 dark:bg-zinc-800"></div>
        </div>
        <div class="flex items-center gap-3">
          <div class="flex items-center gap-2">
            <div class="size-9 animate-pulse rounded-md border border-gray-200 bg-gray-100 dark:border-zinc-700 dark:bg-zinc-800"></div>
            <div class="size-9 animate-pulse rounded-md border border-gray-200 bg-gray-100 dark:border-zinc-700 dark:bg-zinc-800"></div>
          </div>
          <div class="h-5 w-14 animate-pulse rounded-full bg-gray-100 dark:bg-zinc-800"></div>
        </div>
      </div>

      <div class="mt-4 grid min-h-0 flex-1 gap-6 overflow-y-auto lg:grid-cols-3 lg:overflow-hidden">
        <div class="min-w-0 overflow-y-auto rounded-lg border border-gray-200 bg-gray-50 p-4 dark:border-zinc-700 dark:bg-zinc-900 lg:min-h-0">
          <div class="h-9 w-full animate-pulse rounded-md bg-gray-200 dark:bg-zinc-700"></div>
          <div class="mt-6 h-3 w-16 animate-pulse rounded bg-gray-200 dark:bg-zinc-700"></div>
          <div class="mt-2 h-9 w-full animate-pulse rounded-md bg-gray-200 dark:bg-zinc-700"></div>
          <div class="mt-6 h-3 w-20 animate-pulse rounded bg-gray-200 dark:bg-zinc-700"></div>
          <div class="mt-3 flex items-center gap-3">
            <div class="size-12 shrink-0 animate-pulse rounded-full bg-gray-200 dark:bg-zinc-700"></div>
            <div class="min-w-0 flex-1 space-y-2">
              <div class="h-4 w-32 animate-pulse rounded bg-gray-200 dark:bg-zinc-700"></div>
              <div class="h-3 w-16 animate-pulse rounded bg-gray-100 dark:bg-zinc-800"></div>
            </div>
          </div>
          <div class="mt-4 space-y-3">
            @for (field of [0, 1, 2, 3, 4, 5]; track field) {
              <div>
                <div class="h-3 w-14 animate-pulse rounded bg-gray-100 dark:bg-zinc-800"></div>
                <div class="mt-1.5 h-3 w-3/4 animate-pulse rounded bg-gray-200 dark:bg-zinc-700"></div>
              </div>
            }
          </div>
          <div class="mt-6 h-3 w-24 animate-pulse rounded bg-gray-200 dark:bg-zinc-700"></div>
          <div class="mt-3 space-y-2">
            @for (card of [0, 1, 2]; track card) {
              <div class="flex items-start gap-2.5 rounded-md border border-gray-200 bg-white px-2.5 py-2 dark:border-zinc-700 dark:bg-zinc-800">
                <div class="size-8 shrink-0 animate-pulse rounded-md bg-gray-100 dark:bg-zinc-700"></div>
                <div class="min-w-0 flex-1 space-y-1.5">
                  <div class="h-3 w-4/5 animate-pulse rounded bg-gray-200 dark:bg-zinc-700"></div>
                  <div class="h-3 w-1/2 animate-pulse rounded bg-gray-100 dark:bg-zinc-800"></div>
                  <div class="h-3 w-16 animate-pulse rounded bg-gray-100 dark:bg-zinc-800"></div>
                </div>
              </div>
            }
          </div>
        </div>

        <div class="flex h-96 min-h-0 min-w-0 flex-col overflow-hidden rounded-lg border border-gray-200 bg-white dark:border-zinc-700 dark:bg-zinc-900 lg:h-auto lg:min-h-0">
          <div class="min-h-0 flex-1 space-y-4 p-4">
            <div class="rounded-lg border border-gray-200 px-4 py-3 dark:border-zinc-700">
              <div class="h-3 w-12 animate-pulse rounded bg-gray-200 dark:bg-zinc-700"></div>
              <div class="mt-2 h-3 w-24 animate-pulse rounded bg-gray-100 dark:bg-zinc-800"></div>
              <div class="mt-3 h-4 w-2/3 animate-pulse rounded bg-gray-200 dark:bg-zinc-700"></div>
            </div>
            <div class="ml-8 rounded-lg border border-gray-100 px-4 py-3 dark:border-zinc-800">
              <div class="h-3 w-16 animate-pulse rounded bg-gray-200 dark:bg-zinc-700"></div>
              <div class="mt-2 h-3 w-20 animate-pulse rounded bg-gray-100 dark:bg-zinc-800"></div>
              <div class="mt-3 space-y-2">
                <div class="h-4 w-full animate-pulse rounded bg-gray-100 dark:bg-zinc-800"></div>
                <div class="h-4 w-5/6 animate-pulse rounded bg-gray-100 dark:bg-zinc-800"></div>
              </div>
            </div>
          </div>
          <div class="shrink-0 border-t border-gray-200 p-4 dark:border-zinc-700">
            <div class="h-4 w-24 animate-pulse rounded bg-gray-200 dark:bg-zinc-700"></div>
            <div class="mt-2 h-24 w-full animate-pulse rounded-md border border-gray-200 bg-gray-50 dark:border-zinc-700 dark:bg-zinc-800"></div>
            <div class="mt-3 h-9 w-28 animate-pulse rounded-md bg-gray-200 dark:bg-zinc-700"></div>
          </div>
        </div>

        <aside class="flex min-h-0 min-w-0 flex-col overflow-hidden rounded-2xl bg-gradient-to-br from-sky-400 via-violet-500 to-fuchsia-500 p-5 text-white shadow-lg">
          <div>
            <p class="m-0 text-xs font-semibold uppercase tracking-widest text-white/80">Copilot</p>
            <h2 class="mt-1 mb-0 text-lg font-semibold text-white">AI suggestion</h2>
          </div>
          <div class="mt-5 flex min-h-0 flex-1 flex-col gap-4">
            <div class="rounded-2xl bg-white p-4 shadow-sm">
              <div class="h-3 w-20 animate-pulse rounded bg-violet-100"></div>
              <div class="mt-3 space-y-2">
                <div class="h-3 w-full animate-pulse rounded bg-zinc-100"></div>
                <div class="h-3 w-5/6 animate-pulse rounded bg-zinc-100"></div>
                <div class="h-3 w-2/3 animate-pulse rounded bg-zinc-100"></div>
              </div>
              <div class="mt-4 h-9 w-full animate-pulse rounded-full bg-violet-100"></div>
            </div>
            <div class="h-3 w-28 animate-pulse rounded bg-white/40"></div>
            <div class="rounded-xl bg-white/15 px-3 py-2">
              <div class="h-3 w-24 animate-pulse rounded bg-white/40"></div>
              <div class="mt-2 h-4 w-40 animate-pulse rounded bg-white/50"></div>
            </div>
            <div class="rounded-xl bg-white/15 px-3 py-2">
              <div class="h-3 w-28 animate-pulse rounded bg-white/40"></div>
              <div class="mt-2 h-4 w-32 animate-pulse rounded bg-white/50"></div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  } @else if (!ticket()) {
    <button
      type="button"
      (click)="goBack()"
      class="inline-flex shrink-0 items-center text-secondary hover:text-primary"
      aria-label="Back to queue">
      <svg class="size-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
      </svg>
    </button>
    <p class="mt-8 text-sm text-red-600">{{ error() }}</p>
  } @else {
    <div class="mt-0 flex shrink-0 flex-wrap items-start justify-between gap-4">
      <div class="min-w-0">
        <div class="flex items-center gap-2">
          <button
            type="button"
            (click)="goBack()"
            class="inline-flex shrink-0 items-center text-secondary hover:text-primary"
            aria-label="Back to queue">
            <svg class="size-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
            </svg>
          </button>
          <h1 class="m-0 text-2xl font-semibold text-primary">{{ ticket()!.subject }}</h1>
        </div>
        <p class="mt-1 pl-7 text-sm text-secondary">#{{ ticket()!.ticketNumber }} · {{ categoryLabel() }}</p>
      </div>
      <div class="flex items-center gap-3">
        @if (ticketOrder.length > 0) {
          <div class="flex items-center gap-2">
            <button
              type="button"
              (click)="goToPreviousTicket()"
              [disabled]="!previousTicketId"
              class="inline-flex items-center justify-center rounded-md border border-gray-300 dark:border-zinc-600 bg-white dark:bg-zinc-900 p-2 text-secondary hover:bg-gray-50 dark:hover:bg-zinc-800 disabled:cursor-not-allowed disabled:opacity-40"
              aria-label="Previous ticket"
              title="Previous ticket">
              <svg class="size-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
              </svg>
            </button>
            <button
              type="button"
              (click)="goToNextTicket()"
              [disabled]="!nextTicketId"
              class="inline-flex items-center justify-center rounded-md border border-gray-300 dark:border-zinc-600 bg-white dark:bg-zinc-900 p-2 text-secondary hover:bg-gray-50 dark:hover:bg-zinc-800 disabled:cursor-not-allowed disabled:opacity-40"
              aria-label="Next ticket"
              title="Next ticket">
              <svg class="size-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5 15.75 12l-7.5 7.5" />
              </svg>
            </button>
          </div>
        }
        <span
          class="rounded-full px-2.5 py-0.5 text-xs font-medium capitalize"
          [class]="statusClass(ticket()!.status)">
          {{ ticket()!.status }}
        </span>
      </div>
    </div>

    <div class="mt-4 grid min-h-0 flex-1 gap-6 overflow-y-auto lg:grid-cols-3 lg:overflow-hidden">
      <div class="min-w-0 shrink-0 overflow-y-auto rounded-lg border border-gray-200 dark:border-zinc-700 bg-gray-50 dark:bg-zinc-900 p-4 lg:col-span-1 lg:min-h-0">
        @if (ticket()!.status === 'open') {
          <button
            type="button"
            (click)="closeTicket()"
            [disabled]="submitting()"
            class="btn-basic-sm btn-secondary mb-4 w-full disabled:opacity-50">
            Mark closed
          </button>
        }

        <div class="mb-6 min-w-0">
          <label class="block text-xs font-medium text-primary">Assign to</label>
          <div class="mt-2 flex min-w-0 flex-col gap-2">
            <select
              [(ngModel)]="selectedAdminId"
              (ngModelChange)="onSelectedAdminChange()"
              class="w-full min-w-0 rounded-md border border-gray-300 dark:border-zinc-600 bg-white dark:bg-zinc-800 px-3 py-2 text-xs text-primary">
              <option [ngValue]="null">Unassigned</option>
              @for (admin of admins; track admin.userId) {
                <option [ngValue]="admin.userId">{{ admin.firstName }} {{ admin.lastName }}</option>
              }
            </select>
            @if (assignmentChanged()) {
              <button type="button" (click)="assignAdmin()" class="btn-basic-sm btn-secondary w-full">Save</button>
            }
          </div>
        </div>

        <h2 class="text-xs font-semibold text-primary">User info</h2>
        <div class="mt-3 flex items-center gap-3">
          <div
            class="size-12 shrink-0 overflow-hidden rounded-full bg-gray-200 ring-1 ring-gray-200 dark:bg-zinc-700 dark:ring-zinc-600">
            @if (ticket()!.user?.photoURL) {
              <img
                [src]="imageService.getImageSource(ticket()!.user!.photoURL!, 'gallery')"
                [alt]="'Profile picture for ' + (ticket()!.user?.fullName || 'user')"
                class="size-full object-cover" />
            } @else {
              <div
                class="flex size-full items-center justify-center text-secondary"
                aria-hidden="true">
                <svg class="size-7" viewBox="0 0 24 24" fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
                    clip-rule="evenodd" />
                </svg>
              </div>
            }
          </div>
          <div class="min-w-0">
            <p class="m-0 truncate text-sm font-medium text-primary">
              @if (countryFlagForTicket(ticket()!); as flag) {
                <span class="mr-1.5" aria-hidden="true" [title]="flag.label">{{ flag.emoji }}</span>
                <span class="sr-only">{{ flag.label }}</span>
              }
              {{ ticket()!.user?.fullName || '—' }}
            </p>
            <p class="m-0 mt-0.5 text-xs text-secondary">{{ formatUserType(ticket()!.user?.userType) }}</p>
          </div>
        </div>
        <dl class="mt-4 space-y-2 text-xs text-primary">
          <div>
            <dt class="text-secondary">Email</dt>
            <dd>
              @if (ticket()!.user?.email) {
                <button
                  type="button"
                  class="m-0 break-all text-left text-xs hover:underline"
                  [class.text-primary]="!emailCopied()"
                  [class.text-green-600]="emailCopied()"
                  [class.dark:text-green-400]="emailCopied()"
                  [attr.aria-label]="emailCopied() ? 'Copied email' : 'Copy email'"
                  [title]="emailCopied() ? 'Copied' : 'Click to copy'"
                  (click)="copyEmail(ticket()!.user!.email)">
                  {{ ticket()!.user!.email }}
                </button>
              } @else {
                <p class="m-0">—</p>
              }
            </dd>
          </div>
          <div>
            <dt class="text-secondary">User ID</dt>
            <dd>
              @if (ticket()!.user?.userId) {
                <button
                  type="button"
                  class="m-0 break-all text-left text-xs hover:underline"
                  [class.text-primary]="!userIdCopied()"
                  [class.text-green-600]="userIdCopied()"
                  [class.dark:text-green-400]="userIdCopied()"
                  [attr.aria-label]="userIdCopied() ? 'Copied user ID' : 'Copy user ID'"
                  [title]="userIdCopied() ? 'Copied' : 'Click to copy'"
                  (click)="copyUserId(ticket()!.user!.userId)">
                  {{ ticket()!.user!.userId }}
                </button>
              } @else {
                <p class="m-0">—</p>
              }
            </dd>
          </div>
          <div>
            <dt class="text-secondary">Mobile</dt>
            <dd>{{ ticket()!.user?.mobile || '—' }}</dd>
          </div>
          <div>
            <dt class="text-secondary">App version</dt>
            <dd>{{ formatAppVersion(ticket()!.appVersion, ticket()!.appOs) }}</dd>
          </div>
          @if (ticket()!.user?.userType === 'creator') {
            <div class="grid grid-cols-2 gap-3">
              <div class="min-w-0">
                <dt class="text-secondary">Instagram</dt>
                <dd class="truncate">{{ formatSocialProfile(ticket()!.user?.instaHandle, ticket()!.user?.instaFollowers) }}</dd>
              </div>
              <div class="min-w-0">
                <dt class="text-secondary">TikTok</dt>
                <dd class="truncate">{{ formatSocialProfile(ticket()!.user?.tikTokHandle, ticket()!.user?.tikTokFollowers) }}</dd>
                @if (tiktokLoading()) {
                  <p class="m-0 mt-1 text-xs text-secondary">Checking connection…</p>
                } @else if (tiktokConnection(); as connection) {
                  <div class="mt-1 flex flex-wrap items-center gap-2">
                    <p class="m-0 text-xs text-secondary">
                      {{ connection.connected ? 'Connected' : 'Not connected' }}
                      @if (connection.handle) {
                        · {{ connection.handle }}
                      }
                    </p>
                    @if (connection.connected) {
                      <button
                        type="button"
                        class="btn-basic-sm btn-secondary"
                        [disabled]="tiktokDisconnecting()"
                        (click)="disconnectTikTok()">
                        {{ tiktokDisconnecting() ? 'Disconnecting…' : 'Disconnect' }}
                      </button>
                    }
                  </div>
                }
                @if (tiktokError()) {
                  <p class="m-0 mt-1 text-xs text-red-600">{{ tiktokError() }}</p>
                }
              </div>
            </div>
            <div class="grid grid-cols-2 gap-3">
              <div class="min-w-0">
                <dt class="text-secondary">Gender</dt>
                <dd>{{ formatCreatorGender(ticket()!.user?.gender) }}</dd>
              </div>
              <div class="min-w-0">
                <dt class="text-secondary">Country</dt>
                <dd>{{ formatCountry(ticket()!.countryCode) }}</dd>
              </div>
            </div>
          } @else {
            <div>
              <dt class="text-secondary">Country</dt>
              <dd>{{ formatCountry(ticket()!.countryCode) }}</dd>
            </div>
          }
          <div>
            <dt class="text-secondary">Reply alerts</dt>
            <dd>{{ formatAlertPreferences(ticket()!.alertPreferences) }}</dd>
          </div>
        </dl>

        @if (ticket()!.user?.userType === 'creator') {
          <div class="mt-6">
            <h2 class="text-xs font-semibold text-primary">Hired briefs</h2>
            @if (hiredBriefsLoading() === 'loading') {
              <ul class="mt-3 space-y-2" aria-label="Loading hired briefs">
                @for (card of [0, 1, 2]; track card) {
                  <li class="flex items-start gap-2.5 rounded-md border border-green-200 bg-green-100 px-2.5 py-2">
                    <div class="size-8 shrink-0 animate-pulse rounded-md bg-green-200"></div>
                    <div class="min-w-0 flex-1 space-y-1.5">
                      <div class="h-3 w-4/5 animate-pulse rounded bg-green-200"></div>
                      <div class="h-3 w-1/2 animate-pulse rounded bg-green-200"></div>
                      <div class="h-3 w-16 animate-pulse rounded bg-green-200"></div>
                    </div>
                  </li>
                }
              </ul>
            } @else if (hiredBriefsLoading() === 'error') {
              <p class="mt-3 text-xs text-red-600">Could not load hired briefs.</p>
            } @else if (hiredBriefs().length === 0) {
              <p class="mt-3 text-xs text-secondary">No active hired briefs.</p>
            } @else {
              <ul class="mt-3 space-y-2">
                @for (application of visibleHiredBriefs(); track application.id) {
                  <li>
                    <a
                      [routerLink]="['/manage-brief', application.briefId]"
                      class="flex items-start gap-2.5 rounded-md border border-green-200 bg-green-100 px-2.5 py-2 hover:bg-green-200">
                      <div
                        class="flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-md bg-white ring-1 ring-green-200">
                        @if (applicationBrandLogo(application); as logo) {
                          <img
                            [src]="imageService.getImageSource(logo, 'gallery')"
                            alt=""
                            class="size-full object-cover" />
                        } @else {
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            class="size-4 text-zinc-500"
                            aria-hidden="true">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                            <path d="M14 2v6h6" />
                          </svg>
                        }
                      </div>
                      <div class="min-w-0 flex-1">
                        <p class="m-0 min-w-0 text-xs font-medium text-zinc-900">{{ hiredBriefTitle(application) }}</p>
                        <p class="m-0 mt-0.5 truncate text-xs text-zinc-600">{{ hiredBriefSubtitle(application) }}</p>
                        <p class="m-0 mt-1 text-xs font-medium text-green-900">
                          {{ applicationStatusLabel(application.applicationStatus) }}
                        </p>
                      </div>
                    </a>
                  </li>
                }
              </ul>
              @if (showMoreHiredBriefs()) {
                <button
                  type="button"
                  class="mt-2 text-xs font-medium text-indigo-600 hover:underline dark:text-indigo-300"
                  (click)="expandHiredBriefs()">
                  See more
                </button>
              }
            }
          </div>

          <div class="mt-6">
            <h2 class="text-xs font-semibold text-primary">Applied briefs</h2>
            @if (appliedBriefsLoading() === 'loading') {
              <ul class="mt-3 space-y-2" aria-label="Loading applied briefs">
                @for (card of [0, 1, 2]; track card) {
                  <li class="flex items-start gap-2.5 rounded-md border border-orange-200 bg-orange-100 px-2.5 py-2">
                    <div class="size-8 shrink-0 animate-pulse rounded-md bg-orange-200"></div>
                    <div class="min-w-0 flex-1 space-y-1.5">
                      <div class="h-3 w-4/5 animate-pulse rounded bg-orange-200"></div>
                      <div class="h-3 w-1/2 animate-pulse rounded bg-orange-200"></div>
                      <div class="h-3 w-16 animate-pulse rounded bg-orange-200"></div>
                    </div>
                  </li>
                }
              </ul>
            } @else if (appliedBriefsLoading() === 'error') {
              <p class="mt-3 text-xs text-red-600">Could not load applied briefs.</p>
            } @else if (appliedBriefs().length === 0) {
              <p class="mt-3 text-xs text-secondary">No active applications.</p>
            } @else {
              <ul class="mt-3 space-y-2">
                @for (application of visibleAppliedBriefs(); track application.id) {
                  <li>
                    <a
                      [routerLink]="['/manage-brief', application.briefId]"
                      class="flex items-start gap-2.5 rounded-md border border-orange-200 bg-orange-100 px-2.5 py-2 hover:bg-orange-200">
                      <div
                        class="flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-md bg-white ring-1 ring-orange-200">
                        @if (applicationBrandLogo(application); as logo) {
                          <img
                            [src]="imageService.getImageSource(logo, 'gallery')"
                            alt=""
                            class="size-full object-cover" />
                        } @else {
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            class="size-4 text-zinc-500"
                            aria-hidden="true">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                            <path d="M14 2v6h6" />
                          </svg>
                        }
                      </div>
                      <div class="min-w-0 flex-1">
                        <p class="m-0 min-w-0 text-xs font-medium text-zinc-900">{{ hiredBriefTitle(application) }}</p>
                        <p class="m-0 mt-0.5 truncate text-xs text-zinc-600">{{ hiredBriefSubtitle(application) }}</p>
                        <p class="m-0 mt-1 text-xs font-medium text-orange-700">
                          {{ applicationStatusLabel(application.applicationStatus) }}
                        </p>
                      </div>
                    </a>
                  </li>
                }
              </ul>
              @if (showMoreAppliedBriefs()) {
                <button
                  type="button"
                  class="mt-2 text-xs font-medium text-indigo-600 hover:underline dark:text-indigo-300"
                  (click)="expandAppliedBriefs()">
                  See more
                </button>
              }
            }
          </div>
        }

        @if (ticket()!.user?.userType === 'brand') {
          <div class="mt-6">
            <h2 class="text-xs font-semibold text-primary">Recent briefs</h2>
            @if (brandBriefsLoading() === 'loading') {
              <ul class="mt-3 space-y-2" aria-label="Loading recent briefs">
                @for (card of [0, 1, 2]; track card) {
                  <li class="rounded-md border border-gray-200 bg-white px-2.5 py-2 dark:border-zinc-700 dark:bg-zinc-800">
                    <div class="h-3 w-4/5 animate-pulse rounded bg-gray-200 dark:bg-zinc-700"></div>
                    <div class="mt-1.5 h-3 w-1/2 animate-pulse rounded bg-gray-100 dark:bg-zinc-800"></div>
                    <div class="mt-2 h-3 w-16 animate-pulse rounded bg-gray-100 dark:bg-zinc-800"></div>
                  </li>
                }
              </ul>
            } @else if (brandBriefsLoading() === 'error') {
              <p class="mt-3 text-xs text-red-600">Could not load recent briefs.</p>
            } @else if (!ticket()!.businessAccountId) {
              <p class="mt-3 text-xs text-secondary">No business account on this ticket.</p>
            } @else if (brandBriefs().length === 0) {
              <p class="mt-3 text-xs text-secondary">No recent briefs.</p>
            } @else {
              <ul class="mt-3 space-y-2">
                @for (brief of brandBriefs(); track brief.id) {
                  <li>
                    <a
                      [routerLink]="['/manage-brief', brief.id]"
                      class="block rounded-md border border-gray-200 dark:border-zinc-700 bg-white dark:bg-zinc-800 px-2.5 py-2 hover:border-gray-300 hover:bg-gray-50 dark:hover:border-zinc-600 dark:hover:bg-zinc-700/60">
                      <p class="m-0 min-w-0 text-xs font-medium text-primary">{{ brandBriefTitle(brief) }}</p>
                      <p class="m-0 mt-0.5 truncate text-xs text-secondary">{{ brandBriefSubtitle(brief) }}</p>
                      <p class="m-0 mt-1 text-xs font-medium text-indigo-600 dark:text-indigo-300">
                        {{ briefStatusLabel(brief) }}
                      </p>
                    </a>
                  </li>
                }
              </ul>
            }
          </div>
        }

        <div class="mt-6">
          <button
            type="button"
            class="flex w-full items-center justify-between gap-2 text-left"
            [attr.aria-expanded]="timingExpanded()"
            aria-controls="support-ticket-timing"
            (click)="toggleTiming()">
            <h2 class="m-0 text-xs font-semibold text-primary">Ticket stats</h2>
            <svg
              class="size-4 shrink-0 text-secondary transition-transform"
              [class.rotate-180]="timingExpanded()"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
            </svg>
          </button>
          @if (timingExpanded()) {
            <dl id="support-ticket-timing" class="mt-3 space-y-2 text-xs text-primary">
              <div>
                <dt class="text-secondary">Created</dt>
                <dd>{{ formatDateTime(ticket()!.createdDate) }}</dd>
              </div>
              <div>
                <dt class="text-secondary">{{ ticket()!.status === 'closed' ? 'Time to close' : 'Open for' }}</dt>
                <dd>{{ openDurationLabel() }}</dd>
              </div>
              <div>
                <dt class="text-secondary">First response</dt>
                <dd>{{ firstResponseDurationLabel() }}</dd>
              </div>
              <div>
                <dt class="text-secondary">Reopened</dt>
                <dd>{{ reopenCountLabel() }}{{ (ticket()!.reopenCount ?? 0) === 1 ? ' time' : ' times' }}</dd>
              </div>
              @if (ticket()!.closedAt) {
                <div>
                  <dt class="text-secondary">Closed</dt>
                  <dd>{{ formatDateTime(ticket()!.closedAt) }}</dd>
                </div>
              }
            </dl>
          }
        </div>
      </div>

      <div
        class="flex h-96 min-h-0 min-w-0 flex-col overflow-hidden rounded-lg border border-gray-200 dark:border-zinc-700 bg-white dark:bg-zinc-900 sm:h-[32rem] lg:col-span-1 lg:h-auto lg:min-h-0 lg:flex-1">
        <div #messagesContainer class="min-h-0 flex-1 space-y-4 overflow-y-auto p-4">
          @for (message of ticket()!.messages; track message.id) {
            <div class="rounded-lg border px-4 py-3" [class]="messageCardClass(message.authorType)">
              <div class="flex items-start justify-between gap-2">
                <div>
                  <p class="text-xs font-semibold tracking-wide" [class]="messageAuthorClass(message.authorType)">
                    {{ messageAuthorLabel(message) }}
                  </p>
                  <p class="text-xs text-secondary">{{ formatDateTime(message.createdDate) }}</p>
                </div>

                @if (canManageMessage(message) && editingMessageId !== message.id) {
                  <div class="flex items-center gap-2">
                    <button
                      type="button"
                      (click)="startEdit(message)"
                      [disabled]="submitting()"
                      class="text-xs font-light text-indigo-700 hover:text-indigo-900 disabled:opacity-50 dark:text-indigo-300">
                      Edit
                    </button>
                    <button
                      type="button"
                      (click)="deleteMessage(message)"
                      [disabled]="submitting()"
                      class="text-xs font-light text-red-600 hover:text-red-800 disabled:opacity-50">
                      Delete
                    </button>
                  </div>
                }
              </div>

              @if (editingMessageId === message.id) {
                <div class="mt-3 space-y-3">
                  <div class="overflow-hidden rounded-md border border-gray-300 dark:border-zinc-600 bg-white dark:bg-zinc-800 shadow-sm focus-within:border-primary focus-within:ring-1 focus-within:ring-primary">
                    <textarea
                      rows="4"
                      [(ngModel)]="editingBody"
                      class="block w-full border-0 bg-transparent px-3 py-2 text-sm text-primary focus:outline-none focus:ring-0"></textarea>
                    <div class="border-t border-gray-100 dark:border-zinc-700 px-2 py-1.5">
                      <app-support-attachment-input
                        variant="icon"
                        [attachments]="editingAttachments"
                        (attachmentsChange)="onEditingAttachmentsChange($event)"></app-support-attachment-input>
                    </div>
                  </div>
                  <div class="flex gap-2">
                    <button
                      type="button"
                      (click)="saveEdit(message.id)"
                      [disabled]="submitting() || !canSaveEdit()"
                      class="btn-basic-sm btn-primary disabled:opacity-50">
                      {{ submitting() ? 'Saving...' : 'Save changes' }}
                    </button>
                    <button
                      type="button"
                      (click)="cancelEdit()"
                      [disabled]="submitting()"
                      class="btn-basic-sm btn-secondary disabled:opacity-50">
                      Cancel
                    </button>
                  </div>
                </div>
              } @else {
                @if (message.body) {
                  <p class="mt-2 whitespace-pre-wrap text-sm text-primary">{{ message.body }}</p>
                }
                <app-support-attachments-display [attachments]="message.attachments || []"></app-support-attachments-display>
                @if (message.authorType === 'admin' && notificationPills(message).length > 0) {
                  <div class="mt-3 flex flex-wrap items-center gap-1.5">
                    <p class="m-0 text-xs font-medium uppercase tracking-wide text-indigo-500">Notified</p>
                    @for (pill of notificationPills(message); track pill.label) {
                      <span class="rounded-full px-2 py-0.5 text-xs font-semibold" [class]="pill.className">
                        {{ pill.label }}
                      </span>
                    }
                  </div>
                } @else if (isNotificationPending(message)) {
                  <div class="mt-3 space-y-1.5">
                    <p class="text-xs font-medium tracking-wide text-indigo-400">
                      {{ pendingNotificationLabel(message) }}
                    </p>
                    <div class="h-0.5 w-32 overflow-hidden rounded-full bg-indigo-100 dark:bg-indigo-900" aria-hidden="true">
                      <div
                        class="h-full rounded-full bg-indigo-500 transition-all duration-1000 ease-linear"
                        [style.width.%]="notificationProgressPercent(message)"></div>
                    </div>
                  </div>
                }
              }
            </div>
          }
          <div #messagesEnd aria-hidden="true"></div>
        </div>

        <div class="shrink-0 border-t border-gray-200 dark:border-zinc-700 bg-white dark:bg-zinc-900 p-4">
          <div class="flex items-center justify-between gap-3">
            <label class="block text-sm font-medium text-primary">Reply to user</label>

            @if (templateMessages.length > 0) {
              <div class="relative">
                <button
                  type="button"
                  class="btn-basic-sm btn-secondary inline-flex items-center gap-1.5"
                  [attr.aria-expanded]="templatesMenuOpen()"
                  aria-haspopup="menu"
                  aria-controls="support-reply-templates-menu"
                  (click)="toggleTemplatesMenu()">
                  Templates
                  <svg
                    class="size-4 transition-transform"
                    [class.rotate-180]="templatesMenuOpen()"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                  </svg>
                </button>

                @if (templatesMenuOpen()) {
                  <div
                    id="support-reply-templates-menu"
                    role="menu"
                    aria-label="Reply templates"
                    class="absolute right-0 bottom-full z-20 mb-2 w-72 max-w-xs overflow-hidden rounded-md border border-gray-200 dark:border-zinc-700 bg-white dark:bg-zinc-900 shadow-lg">
                    <ul class="max-h-64 divide-y divide-gray-100 dark:divide-zinc-800 overflow-y-auto">
                      @for (template of templateMessages; track template.id) {
                        <li class="flex items-center gap-2 px-3 py-2" role="none">
                          <p class="m-0 min-w-0 flex-1 truncate text-xs font-medium text-primary" [title]="template.label">
                            {{ template.label }}
                          </p>
                          <div class="flex shrink-0 items-center gap-1">
                            <button
                              type="button"
                              role="menuitem"
                              (click)="sendTemplate(template)"
                              [disabled]="submitting()"
                              class="rounded px-2 py-1 text-xs font-semibold text-primary hover:bg-blue-50 dark:hover:bg-zinc-700 disabled:opacity-50"
                              [title]="'Send now: ' + template.label">
                              Send
                            </button>
                            <button
                              type="button"
                              role="menuitem"
                              (click)="insertTemplate(template)"
                              [disabled]="submitting()"
                              class="rounded px-2 py-1 text-xs font-semibold text-primary hover:bg-gray-50 dark:hover:bg-zinc-700 disabled:opacity-50"
                              [title]="'Add to reply: ' + template.label">
                              Insert
                            </button>
                          </div>
                        </li>
                      }
                    </ul>
                  </div>
                }
              </div>
            }
          </div>

          <div
            class="mt-2 overflow-hidden rounded-md border border-gray-300 dark:border-zinc-600 bg-white dark:bg-zinc-800 shadow-sm focus-within:border-primary focus-within:ring-1 focus-within:ring-primary">
            <textarea
              rows="4"
              [(ngModel)]="reply"
              placeholder="Type your message..."
              class="block w-full border-0 bg-transparent px-3 py-2 text-sm text-primary focus:outline-none focus:ring-0"></textarea>
            <div class="border-t border-gray-100 dark:border-zinc-700 px-2 py-1.5">
              <app-support-attachment-input
                variant="icon"
                [attachments]="attachments"
                (attachmentsChange)="onAttachmentsChange($event)"></app-support-attachment-input>
            </div>
          </div>

          @if (error()) {
            <p class="mt-2 text-sm text-red-600">{{ error() }}</p>
          }

          <button
            type="button"
            (click)="sendReply()"
            [disabled]="submitting() || !canSendReply()"
            class="btn-basic-sm btn-primary mt-3 disabled:opacity-50">
            {{ submitting() ? 'Sending...' : 'Send reply' }}
          </button>
        </div>
      </div>

      <aside
        class="flex min-h-0 min-w-0 flex-col overflow-hidden rounded-2xl bg-gradient-to-br from-sky-400 via-violet-500 to-fuchsia-500 p-5 text-white shadow-lg lg:min-h-0">
        <div class="flex shrink-0 items-center justify-between gap-3">
          <div>
            <p class="m-0 text-xs font-semibold uppercase tracking-widest text-white/80">Copilot</p>
            <h2 class="mt-1 mb-0 text-lg font-semibold text-white">AI suggestion</h2>
          </div>
          <button
            type="button"
            class="rounded-full bg-white/20 px-3 py-1.5 text-xs font-semibold text-white hover:bg-white/30 disabled:opacity-50"
            [disabled]="aiLoading() || submitting()"
            (click)="requestAiDraft(true)">
            {{ aiLoading() ? 'Thinking...' : aiSuggestion() ? 'Refresh' : 'Suggest' }}
          </button>
        </div>

        <div class="mt-5 flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto">
          @if (aiLoading() && !aiSuggestion()) {
            <div class="rounded-2xl bg-white p-4 shadow-sm" aria-label="Loading AI suggestion">
              <div class="h-3 w-20 animate-pulse rounded bg-violet-100"></div>
              <div class="mt-3 space-y-2">
                <div class="h-3 w-full animate-pulse rounded bg-zinc-100"></div>
                <div class="h-3 w-5/6 animate-pulse rounded bg-zinc-100"></div>
                <div class="h-3 w-2/3 animate-pulse rounded bg-zinc-100"></div>
              </div>
              <div class="mt-4 h-9 w-full animate-pulse rounded-full bg-violet-100"></div>
            </div>
            <div class="h-3 w-28 animate-pulse rounded bg-white/40"></div>
            <div class="rounded-xl bg-white/15 px-3 py-2">
              <div class="h-3 w-24 animate-pulse rounded bg-white/40"></div>
              <div class="mt-2 h-4 w-40 animate-pulse rounded bg-white/50"></div>
            </div>
            <div class="rounded-xl bg-white/15 px-3 py-2">
              <div class="h-3 w-28 animate-pulse rounded bg-white/40"></div>
              <div class="mt-2 h-4 w-32 animate-pulse rounded bg-white/50"></div>
            </div>
          }

          @if (aiError()) {
            <div class="rounded-2xl bg-white/15 p-4">
              <p class="m-0 text-sm font-medium text-white">{{ aiError() }}</p>
            </div>
          }

          @if (aiSuggestion(); as suggestion) {
            @if (suggestion.needsHuman) {
              <div class="rounded-2xl bg-white/15 p-4">
                <p class="m-0 text-xs font-semibold uppercase tracking-wide text-white/80">Needs a human</p>
                <p class="mt-2 mb-0 text-sm text-white">{{ suggestion.needsHumanReason || 'A human should handle this one.' }}</p>
              </div>
            }

            @if (suggestion.draftBody) {
              <div class="rounded-2xl bg-white p-4 text-zinc-900 shadow-sm">
                <p class="m-0 text-xs font-semibold uppercase tracking-wide text-violet-500">Draft reply</p>
                <p class="mt-3 mb-0 whitespace-pre-wrap text-sm leading-relaxed text-zinc-800">{{ suggestion.draftBody }}</p>
                <button
                  type="button"
                  class="mt-4 w-full rounded-full bg-violet-600 px-4 py-2 text-sm font-semibold text-white hover:bg-violet-500 disabled:opacity-50"
                  [disabled]="submitting()"
                  (click)="useAiDraft()">
                  Use draft
                </button>
              </div>
            }

            @if (suggestion.findings.length > 0) {
              <div>
                <p class="m-0 text-xs font-semibold uppercase tracking-wide text-white/80">What I checked</p>
                <ul class="mt-2 mb-0 space-y-2 pl-0">
                  @for (finding of suggestion.findings; track finding.label + finding.value) {
                    <li class="list-none rounded-xl bg-white/15 px-3 py-2">
                      <p class="m-0 text-xs font-semibold text-white/70">{{ finding.label }}</p>
                      <p class="mt-1 mb-0 text-sm font-medium text-white">{{ finding.value }}</p>
                    </li>
                  }
                </ul>
              </div>
            }

            @if (suggestion.proposedActions.length > 0) {
              <div class="flex flex-col gap-3">
                @for (action of suggestion.proposedActions; track action.id) {
                  @if (action.type === 'notify_dev') {
                    <div class="rounded-2xl bg-white p-4 text-zinc-900 shadow-sm">
                      <p class="m-0 text-xs font-semibold uppercase tracking-wide text-violet-500">
                        Slack the dev team
                      </p>
                      @if (action.payload.message) {
                        <p class="mt-3 mb-0 whitespace-pre-wrap text-sm leading-relaxed text-zinc-800">
                          {{ action.payload.message }}
                        </p>
                      }
                      @if (action.approvedAt) {
                        <p class="mt-4 mb-0 text-sm font-semibold text-zinc-900">
                          Sent{{ action.payload.slackChannel ? ' to ' + action.payload.slackChannel : '' }}
                        </p>
                      } @else {
                        <button
                          type="button"
                          class="mt-4 w-full rounded-full bg-violet-600 px-4 py-2 text-sm font-semibold text-white hover:bg-violet-500 disabled:opacity-50"
                          [disabled]="approvingActionId() === action.id || submitting() || !action.payload.message?.trim()"
                          (click)="approveAiAction(action)">
                          {{ approvingActionId() === action.id ? 'Sending...' : 'Send Slack message' }}
                        </button>
                      }
                    </div>
                  } @else if (action.type === 'nudge_brand') {
                    <div class="rounded-2xl bg-white p-4 text-zinc-900 shadow-sm">
                      <p class="m-0 text-xs font-semibold uppercase tracking-wide text-violet-500">
                        Outbound ticket
                      </p>
                      <p class="mt-2 mb-0 text-xs text-zinc-500">
                        To {{ outboundTicketRecipient(action) }}
                      </p>
                      @if (action.payload.subject) {
                        <p class="mt-3 mb-0 text-sm font-semibold text-zinc-900">{{ action.payload.subject }}</p>
                      }
                      @if (action.payload.message) {
                        <p class="mt-2 mb-0 whitespace-pre-wrap text-sm leading-relaxed text-zinc-800">
                          {{ action.payload.message }}
                        </p>
                      }
                      @if (action.approvedAt) {
                        <p class="mt-4 mb-0 text-sm font-semibold text-zinc-900">Sent</p>
                        @if (action.payload.createdTicketId) {
                          <a
                            [routerLink]="['/support-admin', action.payload.createdTicketId]"
                            class="mt-2 inline-block text-sm font-semibold text-violet-600 hover:text-violet-500">
                            Open ticket
                          </a>
                        }
                      } @else {
                        <button
                          type="button"
                          class="mt-4 w-full rounded-full bg-violet-600 px-4 py-2 text-sm font-semibold text-white hover:bg-violet-500 disabled:opacity-50"
                          [disabled]="approvingActionId() === action.id || submitting() || !canSendOutboundTicket(action)"
                          (click)="approveAiAction(action)">
                          {{ approvingActionId() === action.id ? 'Sending...' : 'Send outbound ticket' }}
                        </button>
                      }
                    </div>
                  } @else {
                    <button
                      type="button"
                      class="w-full rounded-full bg-white/20 px-4 py-2 text-sm font-semibold text-white hover:bg-white/30 disabled:opacity-50"
                      [disabled]="!!action.approvedAt || approvingActionId() === action.id || submitting()"
                      (click)="approveAiAction(action)">
                      {{ action.approvedAt ? 'Done: ' + action.label : approvingActionId() === action.id ? 'Working...' : action.label }}
                    </button>
                  }
                }
              </div>
            }
          } @else if (!aiLoading() && !aiError()) {
            <div class="rounded-2xl bg-white/15 p-4">
              <p class="m-0 text-sm text-white/90">Open a waiting ticket and a draft will appear here.</p>
            </div>
          }
        </div>
      </aside>
    </div>
  }
</div>
